import { postDataFile } from "./rest-api-helper"

export async function poTrackingExcelServ({ filterObj, columns, doColumns }) {
    const details = {
        urlPath: "/excel/poTrackingExcel",
        body: {
            filterObj: { ...filterObj }, columns: [...columns], doColumns: [...doColumns]
        }
    }
    console.log(details)
    const res = await postDataFile(details);
    return res
}